"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[380],{

/***/ 81100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ catalog; }
});

// EXTERNAL MODULE: ./lib/i18n/iso6391.ts + 3 modules
var iso6391 = __webpack_require__(49711);
;// CONCATENATED MODULE: ./lib/items/buy.ts

var buy = [
    {
        category: "buy",
        link: "https://lgt.st/swan",
        image: "swan.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/AM3i9wlHbAA5X8/j+AAAK1LB1+1uja0ABDUABEFn7///vNToAClRANnt/z5oigA0XN3w/32KGWQSLeGBAAAAAElFTkSuQmCC",
        name: "Swan",
        slogan: "Swan Bitcoin provides savings plans, instant buys, Private Client for businesses and HNWI, Advisor Services for financial advisors, and world-class Bitcoin education.",
        platforms: [
            "web",
            "mobile"
        ]
    },
    {
        category: "buy",
        link: "https://lgt.st/strike",
        image: "strike.webp",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAJUlEQVR4nGNgQAYiIiL79++/deuWoKAgiJ+RkfHr1y9PT08UVQAE+Ao8BpEpowAAAABJRU5ErkJggg==",
        name: "Strike",
        slogan: "Send and receive money instantly.",
        platforms: [
            "web",
            "mobile",
            "desktop"
        ]
    },
    {
        category: "buy",
        link: "https://lgt.st/cashapp",
        image: "cashapp.png",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMElEQVR4nGNg0GRgsGBgSGYAMRiUGNre5c//38GgzgASqHmWuvb/NLCMJliNI4gBABEUCpGscxy/AAAAAElFTkSuQmCC",
        name: "Cash App",
        slogan: "The #1 finance app in the App Store. Pay anyone, instantly. Design a debit card to match your style. Invest in stocks or bitcoin with as little as $1.",
        platforms: [
            "web",
            "mobile"
        ]
    },
    {
        category: "buy",
        link: "https://lgt.st/river",
        image: "river.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAN0lEQVR4nGPg4uISERERFxfj4uJiYGBg+P/n2Z93N0AsVRWl57ePnN67Wl1VhUFQUJAVDAQFBQBKDQx3tn6HcAAAAABJRU5ErkJggg==",
        name: "River",
        slogan: "Easily buy, sell and mine Bitcoin in the USA. River has world-class security, leading customer support, and zero fees on recurring orders.",
        platforms: [
            "web",
            "mobile"
        ]
    },
    {
        category: "buy",
        link: "https://lgt.st/azteco",
        image: "azteco.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOElEQVR4nGP48P7t8xfPX7589e7jBwZeNfOAwDBbN1sNATkGBlG1mIQUXTM9EOfz5w+PHz+CKAMAu6ka0GnYBDMAAAAASUVORK5CYII=",
        name: "Azteco",
        slogan: "Azteco: the easiest way to buy Bitcoins.",
        platforms: [
            "web",
            "mobile"
        ]
    },
    {
        category: "buy",
        link: "https://lgt.st/noah",
        image: "noah.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVR4nGOIZ2CAoBwGBoYbagz/23z+tzo/t2Fg+Bcu9X9BzP+jlf+rVBmSGBiKGBhaGBjWMTAAAKEsEI7xoz7UAAAAAElFTkSuQmCC",
        name: "NOAH",
        slogan: "Send, Save, Pay and Earn with NOAH, the all-in-one money app of the future.",
        platforms: [
            "web",
            "mobile"
        ]
    },
    {
        category: "buy",
        link: "https://lgt.st/amber",
        image: "amber.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/AP///9rb2/Hx8f///wDd3d0aHB1dX1////8Aubm5AAUOQzwt892vAPv6+tfY2evn4vvz45T/IsURi+WbAAAAAElFTkSuQmCC",
        name: "amber",
        slogan: "\uD83C\uDF0F Amber app is expanding and bringing easy Bitcoin accumulation to a country near you.",
        platforms: [
            "web",
            "mobile"
        ]
    },
    {
        category: "buy",
        link: "https://lgt.st/shakepay",
        image: "shakepay.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOElEQVR4nGNgENJkEFIDIw0GTteE3t//O378Z7AMYmDQcl33///8//8ZlG0YGFiVGcR1GMQ0gQwAbSIODqPW9PwAAAAASUVORK5CYII=",
        name: "shakepay",
        slogan: "Shakepay allows Canadians to buy/sell bitcoin and pay their friends. We're on a mission to create open access to building wealth.",
        platforms: [
            "web",
            "mobile"
        ]
    },
    {
        category: "buy",
        link: "https://lgt.st/bullbitcoin",
        image: "bullbitcoin.png",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJklEQVR4nGOIZWCAI4YcBobfbb3/OidkMYAF/j948v/eI5AMsjIAbNAOIO3hlRQAAAAASUVORK5CYII=",
        name: "Bull Bitcoin",
        slogan: "Bull Bitcoin is a non-custodial Bitcoin exchange and payments service. Our mission is to empower Canadians to take back control over their money.",
        platforms: [
            "web",
            "mobile"
        ]
    },
    {
        category: "buy",
        link: "https://lgt.st/pocket",
        image: "pocket.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVR4nGPQZ9iYwLA3jGGHPsNGBjOGTe9P/P//478GwxoGC4ZNb079n5y5k4FhIojjyLCFgaFelGEdACj4FFqC4nZ2AAAAAElFTkSuQmCC",
        name: "Pocket",
        slogan: "Experience the best way to buy and store Bitcoin. From your bank account directly into your self-custody. One-off or recurring at the most recent exchange rate.",
        platforms: [
            "web",
            "mobile"
        ]
    },
    {
        category: "buy",
        link: "https://lgt.st/casa",
        image: "casa.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANklEQVR4nGNgYOhkYJjCwDCHgWEGAwPDhEfn/+9c+J+BYSqI8//9/0t7oJxOBoY+BoYJDAwzAbscEV8Aou+YAAAAAElFTkSuQmCC",
        name: "Casa",
        slogan: "Casa is the leading provider of Bitcoin self-custody solutions. Buy, sell, and receive bitcoin with our ultimate blend of security, privacy, and control.",
        platforms: [
            "web",
            "mobile"
        ]
    },
    {
        category: "buy",
        link: "https://lgt.st/peach",
        image: "peach.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPUlEQVR4nGOIYGCYws+wJ0hiXwQDQyIDw/+tc/+/OrHBiZkhn4Hh/+MLj5sy2xgYGCIYGEoZGMIYGGIYGADVsBCEgNfnOgAAAABJRU5ErkJggg==",
        name: "Peach",
        slogan: "Peach: Buy and Sell bitcoin the way you want!",
        platforms: [
            "web",
            "mobile"
        ]
    },
    {
        category: "buy",
        link: "https://lgt.st/coinbits",
        image: "coinbits.jpg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/AIvOvQBbPgBLLX3FsgAAHwAIjHLe//oAMA4AAB0AKJZ+l9TFACgAAITKuQBRNAAzEXS+rNK3EbWhSlrDAAAAAElFTkSuQmCC",
        name: "Coinbits",
        slogan: "Coinbits is the best choice for people who want to get started with bitcoin quickly and safely, with no long-term commitment.",
        platforms: [
            "web"
        ]
    },
    {
        category: "buy",
        link: "https://lgt.st/relai",
        image: "relai.png",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/AAAAYVRgwVNgvwAAYQBBUbHl6//d5P8+T7IAPU6v6vH/5Ov/PU6vAAAAYFNgwFNgwAAAX12yF3wJteCsAAAAAElFTkSuQmCC",
        name: "Relai",
        slogan: "Relai is a Bitcoin investment app that allows anyone to buy bitcoin within one minutes or set up an automated savings plan.",
        platforms: [
            "web"
        ]
    },
    {
        category: "buy",
        link: "https://lgt.st/bottlepay",
        image: "bottlepay.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVR4nGOQl1cvK6tWUNBgZuZlsLf3+PP779atO9TUDBgcHDy+f/uxbdtOTU0jBllZtdycIllZFaAyAMluERJ+0pmSAAAAAElFTkSuQmCC",
        name: "Bottlepay",
        slogan: "Bottlepay makes buying bitcoin easy. Make a one-off purchase or set up a recurring trade hourly, daily, weekly or monthly.",
        platforms: [
            "web"
        ]
    }, 
];

;// CONCATENATED MODULE: ./lib/items/donate.ts

var donate = [
    {
        category: "donate",
        link: "https://lgt.st/tallycoin",
        image: "tallycoin.png",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/ADw+Ra6utFpbYgsOFgDJydD3+P+9vsRUVVsAmpqg3N3j+/v/paesAAEDD52dpNbW3EdIUK78G17JIbcqAAAAAElFTkSuQmCC",
        name: "Tallycoin",
        slogan: "Tallycoin is a bitcoin crowdfunding platform where all donations go to a wallet under your control. Zero fees.",
        platforms: [
            "web"
        ]
    },
    {
        category: "donate",
        link: "https://lgt.st/geyserfund",
        image: "geyserfund.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPUlEQVR4nGMQYmKVz4+XyYoVYGBgkAz3Kfv/Pv7NSclADwbt1tL03zdy/z+SSY1kEBET02gokI4JFGRgBQCnGhCdU9nkRgAAAABJRU5ErkJggg==",
        name: "Geyser Fund",
        slogan: "Geyser is a bitcoin crowdfunding platform that enables campaign creators to launch their projects with rewards and engage their communities with posts and content.	",
        platforms: [
            "web"
        ]
    },
    {
        category: "donate",
        link: "https://lgt.st/opensats",
        image: "opensats.png",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAN0lEQVR4nGOIZGAIZWDIYGCoZ2BgKGNgOGrLEAvmM5xyYrgdyrBKHMRn+H8zca8JQw0DQyQDAwACCwss9NtbpQAAAABJRU5ErkJggg==",
        name: "Open Sats",
        slogan: "Open source dev funding powered by sats - 100% pass through with no management fees - 501(c)(3) approved - bitcoin for a better world! ",
        platforms: [
            "web"
        ]
    },
    {
        category: "donate",
        link: "https://lgt.st/machankura",
        image: "machankura.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOklEQVR4nGP4/81y5xyGC5sY/v+2Zvj/w9LJhMHJhOH/LysQNlRmkGFg+P9cDySzbSbD/X18///aAACLbBijIMSA+AAAAABJRU5ErkJggg==",
        name: "Machankura",
        slogan: "Use Bitcoin on any mobile phone! Machankura turns your phone into a lightning wallet allowing you to send and receive bitcoin with just your mobile number.",
        platforms: [
            "web"
        ]
    },
    {
        category: "donate",
        link: "https://lgt.st/bitcoinekasi",
        image: "bitcoinekasi.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPUlEQVR4nGNgZWVz9fT3CwxjZ2dn0Dc0+rK79PeleUbG5gyc3Hz/vyz9f6VDQlKWgYGBQVRU1M3Tn42dHQCD6g5J96ZEDAAAAABJRU5ErkJggg==",
        name: "Bitcoin Ekasi",
        slogan: "Bitcoin Ekasi (Mossel Bay, South Africa) is inspired by Bitcoin Beach (El Zonte, El Salvador) Bitcoin Ekasi is an extension of The Surfer Kids Non-Profit.",
        platforms: [
            "web"
        ]
    },
    {
        category: "donate",
        link: "https://lgt.st/bitcoinbeach",
        image: "bitcoinbeach.png",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/AP///7eVZrmYaf///wD///+DUQCCUQD+//8A5+jpBwQEHBoZ5OXmAPLy8ltcYmZpbvLy80mGHs83LiIlAAAAAElFTkSuQmCC",
        name: "Bitcoin Beach",
        slogan: "Bitcoin Beach - The first circular economy on bitcoin.",
        platforms: [
            "web"
        ]
    },
    {
        category: "donate",
        link: "https://lgt.st/praiabitcoin",
        image: "praiabitcoin.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANklEQVR4nB3CMQqAMBAAsNDnCS5FOnQ5/yxd9QVCt44nGCLnaDTyvQT9H9g42KnIdQdnkev5AI8SD0lgCisdAAAAAElFTkSuQmCC",
        name: "Praia Bitcoin",
        slogan: "Inspired by Bitcoin Beach optimized to Brazil, Praia Bitcoin experiment is building a Bitcoin Circular Economy in Jericoacoara- Cear\xe1.",
        platforms: [
            "web"
        ]
    },
    {
        category: "donate",
        link: "https://lgt.st/pacodelaindia",
        image: "pacodelaindia.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/ACUaEd2xmYF0Yi0lGgA6KBzHnZFxXFz/6ckAclk858bS4anC566OAEI4JP/i2v/i4xcOAEkIGL9RVnN6AAAAAElFTkSuQmCC",
        name: "Run with Bitcoin",
        slogan: "22/40 countries traveled with Bitcoin",
        platforms: [
            "web"
        ]
    },
    {
        category: "donate",
        link: "https://lgt.st/bff",
        image: "bitcoinforfairness.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/AOro6A0IDQcAA/Lv8ACYl5txXEiCe3eTkJMAdnV3W0Y1TkhFZmNlAPLw8BwaHh0YGf77/EVfFmsnYQNqAAAAAElFTkSuQmCC",
        name: "Bitcoin for Fairness",
        slogan: "Bitcoin for Fairness is a non-profit raising knowledge and understanding of BTC for people in emerging countries and for the disadvantaged.",
        platforms: [
            "web"
        ]
    }, 
];

;// CONCATENATED MODULE: ./lib/items/earn.ts

var earn = [
    {
        category: "earn",
        link: "https://lgt.st/solitaire",
        image: "thndr-solitaire.webp",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAP0lEQVR4nAE0AMv/AOMAbJMAUzoAIK0ANgDiKH+Vfnn/6ImSHyEA4wA3RCQ6TxcZ3GUOANwAPfxGktE1hOUAId7nEtECeqFiAAAAAElFTkSuQmCC",
        name: "Club Bitcoin: Solitaire",
        slogan: "If you like Solitaire, then you will fall in love with Club Bitcoin. Play the most tantalizing Classic Solitaire game on the market while earning Bitcoin! What more could you want?",
        platforms: [
            "mobile"
        ]
    },
    {
        category: "earn",
        link: "https://lgt.st/bounce",
        image: "thndr-bounce.webp",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAOUlEQVR4nGPgYmbIdxLMdxLmYmZgKHAS+f+o+P/z2lxHYTDnVdP/+wW5TsIM3GxM+U7CuU4i3GxMAJ9BD81L0GuaAAAAAElFTkSuQmCC",
        name: "Bitcoin Bounce - Earn Bitcoin",
        slogan: "See how far you can bounce along the Blockchain, trying not to fall! A challenging game that requires fast reflexes and timing.",
        platforms: [
            "mobile"
        ]
    },
    {
        category: "earn",
        link: "https://lgt.st/turbo84",
        image: "thndr-turbo84.webp",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAP0lEQVR4nAE0AMv/AP+WuP+wkv+ghf94lAA1HBL/7X3/7H4iDQsAfUd2/69o+pxOGwAKALEbdP9mwv9owYkHUt6jGfdntW0OAAAAAElFTkSuQmCC",
        name: "Turbo 84 - Earn Real Bitcoin",
        slogan: "Can you reach 100 mph? How about 200 mph? Drive as fast as you can through this insane lane changing game. Just try not to crash on your way to reaching your top speed!",
        platforms: [
            "mobile"
        ]
    },
    {
        category: "earn",
        link: "https://lgt.st/snake",
        image: "thndr-snake.webp",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAPUlEQVR4nGNgMBBkEGIIDxDcfbqPgYFHksGGQfH2tN6jRQzFFbr/32Yk1aul3FnKoF9kXO/CkH8kY9O5ZACLLBJETZxN8wAAAABJRU5ErkJggg==",
        name: "Bitcoin Snake: Earn Bitcoin",
        slogan: "The Classic Snake game - now with Bitcoin! One of the most well known and most popular mobile games in the world now has a new twist!",
        platforms: [
            "mobile"
        ]
    },
    {
        category: "earn",
        link: "https://lgt.st/bay",
        image: "thndr-bay.webp",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAPUlEQVR4nGNwztL9/27n/9+XG5akMxS0ZiZJMAQwMLRWezC0r99fYSyWK8swZeU6BlUGx40MhZsYMnUYfABNyROPra5XzQAAAABJRU5ErkJggg==",
        name: "Bitcoin Bay: Earn Real Bitcoin",
        slogan: "A bubble shooter game set in a beautiful tropical location! Have fun and chill by downloading this relaxing seaside bubble shooter today.",
        platforms: [
            "mobile"
        ]
    },
    {
        category: "earn",
        link: "https://lgt.st/lolli",
        image: "lolli.webp",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAOUlEQVR4nGNgYMj0kpjmJTGNgSGTwZS56//r//9f/7dm72Ww4e7/cun/l0tgDgNDpoPQJAehSUBlAAZ/E+8RsvC1AAAAAElFTkSuQmCC",
        name: "Lolli - Earn $5",
        slogan: "Lolli is a rewards application that gives you bitcoin when you shop at your favorite stores.",
        platforms: [
            "mobile",
            "desktop"
        ]
    },
    {
        category: "earn",
        link: "https://lgt.st/fold",
        image: "fold.webp",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAALElEQVR4nGP4/90NhM6p///uxvD/u5uOIIOBBIgBwmoMDAdnwjj/L2lBFAMA4XgcTdRnW0cAAAAASUVORK5CYII=",
        name: "Fold - Earn 20,000 sats ",
        slogan: "Fold is the bitcoin rewards debit card and bitcoin-back shopping app. Earn bitcoin on everything with the Fold bitcoin cashback debit card. Request access to sign up for our bitcoinback debit card.",
        platforms: [
            "mobile",
            "desktop"
        ]
    },
    {
        category: "earn",
        link: "https://lgt.st/carrot",
        image: "carrot.webp",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAN0lEQVR4nGNgYGCY+q9o6r8iBgiY+rN42k8w5/+Vyv+n8v+fyP9/upTh//G8/ycK/58r+X82BwAoORnrkrmJWQAAAABJRU5ErkJggg==",
        name: "Carrot",
        slogan: "Carrot gives you a place to earn bitcoin for by reading articles about Bitcoin and supporting your favorite communities, organizations, and initiatives! Ready to earn?",
        platforms: [
            "mobile",
            "desktop"
        ]
    },
    {
        category: "earn",
        link: "https://lgt.st/stackernews",
        image: "stackernews.png",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/AP/jRuPDK//6V//lSACvlAAoCwA6KQBIOAAArZQAKAgAIwAAKxMAAOPDK/zaPv/3Vf/pSjR2FQNtGRUKAAAAAElFTkSuQmCC",
        name: "stacker news",
        slogan: "It's like Hacker News but we pay you Bitcoin.",
        platforms: [
            "desktop"
        ]
    },
    {
        category: "earn",
        link: "https://lgt.st/satsback",
        image: "satsback.png",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOElEQVR4nGNgYJBgU9Fi09ZjYJBgcOzOmvH/SP//3Y7dWSBO///dM/4fsWvPZAAp09RlU9ECKgMAmsIP3J9YTmcAAAAASUVORK5CYII=",
        name: "satsback",
        slogan: "Satsback is the evolution of cashback and loyalty rewards - the easiest and safest way to start saving bitcoin with more than 10,000 connected merchants.",
        platforms: [
            "desktop"
        ]
    },
    {
        category: "earn",
        image: "thebitcoincompany.jpg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/thebitcoincompany",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/AFwAAEoAAEkAAFEADQDCYFD/4N7/x8ytQFQAwGIx/9u5/8CnggAPAI4oAHgAAHQAAH4AAN8HEk3sGa4dAAAAAElFTkSuQmCC",
        name: "The Bitcoin Company",
        slogan: "The easiest way to spend bitcoin and earn rewards.",
        platforms: [
            "mobile"
        ]
    },
    {
        category: "earn",
        image: "satsy.png",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/satsy",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAL0lEQVR4nGP4/81jcwfD8jqG/988GFY3MigxgNC2LjCGcFY3MoBkl9cxbO4AKQMA+SUTFX6c+GYAAAAASUVORK5CYII=",
        name: "Satsy",
        slogan: "Just sign up, shop, and get some free bitcoin. Answer a few surveys, and stack more sats. Lots of ways to earn risk free bitcoin	",
        platforms: [
            "desktop"
        ]
    },
    {
        category: "earn",
        image: "oshi.png",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/oshi",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALklEQVR4nGNgYGBgYWERFxdnZmZmYGBgePPmzb9//0AsTk7O3bt329jYgDjIAAAHRwkZ5bhLBwAAAABJRU5ErkJggg==",
        name: "Oshi",
        slogan: "Earn bitcoin by supporting your local economy.",
        platforms: [
            "mobile"
        ]
    },
    {
        category: "earn",
        image: "fountain.webp",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/fountain",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAKklEQVR4nGNgYGDwszV4dGA+AwR82Dbx/+dDUM67g1N6yqOgHAt9ZQgLAHLVDBIE5xavAAAAAElFTkSuQmCC",
        name: "Fountain",
        slogan: "Listen, learn, and earn for the value you bring to Fountain. Available on iOS and Android.",
        platforms: [
            "mobile"
        ]
    },
    {
        category: "earn",
        image: "smiles.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/smiles",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVR4nGNg0J7NELiXofIuiMEg2TX36f/FL/8zyE8AcSbf/r/7138GsTYGBu4yhoAtDPZLGdhKAAglE5JG6rZ2AAAAAElFTkSuQmCC",
        name: "sMiles",
        slogan: "Bitcoin App for iOS or Android to Earn Free Bitcoin. How To Get Free Bitcoin Instantly. Playing Games. Proof of Work. Win. BTC. Sats. Free Bitcoin.",
        platforms: [
            "mobile"
        ]
    },
    {
        category: "earn",
        image: "webdeveloper.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/webdeveloper",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAHElEQVR4nGNgQAOzZ8/+/fs3lNPZ2fnixQt0JQDrzAkW1WcG8wAAAABJRU5ErkJggg==",
        name: "webdeveloper",
        slogan: "Serving the #webDeveloper community, earn sats",
        platforms: [
            "desktop"
        ]
    },
    {
        category: "earn",
        image: "zebedee.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/zebedee",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVR4nGMQFtfg4JTi4JQSk9RmqKyb9OXn/w9f/heVdTGUV/ffe/zjwbPfWblNDMLiGqwcUsxsEkBlAPPnExX6CVBpAAAAAElFTkSuQmCC",
        name: "ZEBEDEE",
        slogan: "We make the points you earn in games matter. By harnessing the power of Bitcoin, we attach real-world value to points, scores and economies in virtual worlds",
        platforms: [
            "mobile"
        ]
    },
    {
        category: "earn",
        image: "sparkwallet.png",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/spark",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALElEQVR4nGNgYGBgY+OQk1ZkgID/a57+v/8fxjl6+/+Co1COnIQYCzMTkAUAKGcLNDsIiM4AAAAASUVORK5CYII=",
        name: "Spark Wallet",
        slogan: "Earn Rewards on every transaction. Send and receive instantly. Get a visa debit card. Swap your bitcoin. Buy gift cards at 5% back. Earn free rewards when sharing Spark Wallet with your friends!",
        platforms: [
            "mobile"
        ]
    },
    {
        category: "earn",
        image: "mintgox.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/mintgox",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPUlEQVR4nGPg5RFmY+NjZ+Ph5ORmUFe1uXDhxrVr91VVzRhUFX3//P7/+uV/FSUXBh5OaW5OFQ5WFX4+JQBmIg5GKdnLfAAAAABJRU5ErkJggg==",
        name: "MintGox",
        slogan: "Play games. Collect Bitcoin. Spend them! MintGox is a brand new style of esports tournament. Games become more engaging and rewarding when real currency is added, so we went ahead and did just that! Now you can earn Bitcoin, tip streamers and even power up your favorite players! Welcome to the future of esports!",
        platforms: [
            "mobile"
        ]
    },
    {
        category: "earn",
        image: "mash.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/mash",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/AP///3OQn4qotP///wB/l6UAFTNPSVbKqK0Akay6QUJSSAAAuJCZAP///8qqr7yXnfz+/vWXHZDKwiirAAAAAElFTkSuQmCC",
        name: "Mash",
        slogan: "Mash is the easiest creators and indie hackers to earn money and get donations. Make money for your Tools, Apps, Software, Games, Newsletters, Interactive Experiences, Live-Streams, Video Content, Education Content, Bogs, Articles, Local News and Podcasts.",
        platforms: [
            "desktop"
        ]
    },
    {
        category: "earn",
        image: "slice.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/slice",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/AAAAmgA3xAA7xwACmwB9g/n09v/Exf+Wm/8ADUPNv8L/4uT/ZXHsAAAAkwA8yCRJ0QAAk3KyGFsJl3meAAAAAElFTkSuQmCC",
        name: "Slice",
        slogan: "Add the Slice extension to your browser today and claim your fair share of the $455 billion digital advertising pie.",
        platforms: [
            "desktop"
        ]
    },
    {
        category: "earn",
        image: "lncal.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/lncal",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/AKyHjDkAADcAAL6ipQCelJBPLQZJJwOxqaUA3dfPiWYqlXVC0svEAPr6+9HFttnOv/3+/yu8Gs/wUWE5AAAAAElFTkSuQmCC",
        name: "LNCal.com",
        slogan: "Earn Bitcoins by getting booked on your public calendar.",
        platforms: [
            "desktop"
        ]
    },
    {
        category: "earn",
        image: "satscrap.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/satscrap",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVR4nGP4////ks7cbfO7////z/D8/jVbPoZII4af37+COKYMDHb8DG+fP2T4////qglla6dUA5UBACp/HwWt/bLaAAAAAElFTkSuQmCC",
        name: "SatsCrap",
        slogan: "An online Bitcoin marketplace",
        platforms: [
            "desktop"
        ]
    },
    {
        category: "earn",
        image: "tweetoshi.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/tweetoshi",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOklEQVR4nGNgYO9QqbjDEHiAgaGZgUF8ytLT/7ff/s8gPZ2BgbOTwXfvo7//GbQXM4Bk3XcwOGwGMgDhYxI52OMnKAAAAABJRU5ErkJggg==",
        name: "Tweetoshi",
        slogan: "Get Bitcoin daily just for using Twitter! — Twitter client which shares revenue with users and has integrated lightning network for tipping with no KYC.	",
        platforms: [
            "mobile"
        ]
    }, 
];

;// CONCATENATED MODULE: ./lib/items/learn.ts

var learn = [
    {
        category: "learn",
        image: "bitcoin.svg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        platforms: [
            "web"
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAN0lEQVR4nBXJMRHAIBAAsMwIoxwTAlCCkuqoCGQgAgNfWBMPjZ5UZGKOWG9GIfYXcxTu9nTpzA9c5A04Wb1MyAAAAABJRU5ErkJggg==",
        name: "Bitcoin White Paper",
        slogan: "A Peer-to-Peer Electronic Cash System",
        link: "/bitcoin.pdf",
        difficulty: "hard"
    },
    {
        category: "learn",
        image: "bitcoinrocks.jpg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        platforms: [
            "web",
            "mobile"
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALklEQVR4nGNgYGBgZICBP4c6/19b/P/Z2lOzchimNeX//vL2/++PVblxcBUgAADVNxG2vqHGpgAAAABJRU5ErkJggg==",
        name: "Bitcoin Rocks",
        slogan: "Learn about Bitcoin using our educational articles, videos, and more!",
        link: "https://lgt.st/bitcoinrocks",
        difficulty: "easy"
    },
    {
        category: "learn",
        image: "sayloracademy.png",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        platforms: [
            "web",
            "mobile"
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/AOLj5MbKy97k6PDy8wAgLC8AGyRmgpCbrbQAbXV2Dyo0ABAdYGxtAPf397rAxL3Eyerr690NHAp/k8G8AAAAAElFTkSuQmCC",
        name: "Saylor Academy",
        slogan: "Bitcoin is increasingly being adopted as pristine collateral, a longer-term store of value, and unstoppable money",
        link: "https://lgt.st/sayloracademy",
        difficulty: "hard"
    },
    {
        category: "learn",
        image: "bitcoinqa.png",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        platforms: [
            "web"
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/ABQRKS0lOyAaMBUULAAaHTaj9/99zPwUESkAEgglmNv3cr7kDgAeAC04VJPq/6j//0+WxIl9E6EXA4E0AAAAAElFTkSuQmCC",
        name: "Bitcoin Q+A",
        slogan: "A collection of Bitcoin resources by Bitcoin Q+A",
        link: "https://lgt.st/bitcoinqa",
        difficulty: "hard"
    },
    {
        category: "learn",
        image: "jamesonlopp.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        platforms: [
            "web"
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPUlEQVR4nGPQsTPevH51T0sdm4Qkg4a53v8//5ZvuyCprs7AwC4d5RFmqmzKICzGULTunHHaVBYlL0lrPwDZAhCITEndwAAAAABJRU5ErkJggg==",
        name: "Jameson Lopp",
        slogan: "If you're looking for structured sets of lecture materials and challenges, one of the many online courses may be helpful. Most of the online courses are free or fairly low cost.",
        link: "https://lgt.st/jamesonlopp",
        difficulty: "hard"
    }, 
];

;// CONCATENATED MODULE: ./lib/items/save.ts

var save = [
    {
        category: "save",
        image: "trezor.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        platforms: [
            "web"
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKklEQVR4nB3JsQ0AIBDDQLfZwYtQsj4zUTzkKksG2AWQ5FYS1FPqn6teDX4wDl+IxOk6AAAAAElFTkSuQmCC",
        name: "Trezor",
        slogan: "Trezor hardware wallets are the safest and most resilient way to secure Bitcoin assets offline.",
        link: "https://lgt.st/trezor?aff_sub={{userId}}"
    },
    {
        category: "save",
        image: "coldcard.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        platforms: [
            "web"
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/AP/09PHZ2f/09P/09ACRVlk+AAB2NDl9P0EAm2NkRAAAOwAAgEBEAP/09Pvo6Pvm5v/09PgpHPwvH3F5AAAAAElFTkSuQmCC",
        name: "COLDCARD",
        slogan: "COLDCARD Is The Most Trusted and Secure Bitcoin Signing Device (aka. Bitcoin Hardware Wallet)",
        link: "https://lgt.st/coldcard"
    },
    {
        category: "save",
        image: "ledger.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        platforms: [
            "web"
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOElEQVR4nAXBoREAMAgDQGaIqENE5A6BYT5WYFc0rv8GICIkvfeM5O52d2aau9/dzFSVAZBEEsAHWt4NPCHj1HgAAAAASUVORK5CYII=",
        name: "Ledger",
        slogan: "Secure your Bitcoin. Give yourself peace of mind by knowing that your Bitcoin is safe",
        link: "https://lgt.st/ledger"
    },
    {
        category: "save",
        image: "seedsigner.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        platforms: [
            "web"
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMklEQVR4nGP48/v3rx8//oMBw5F186YUBJgzMETqMjAcXDVzanGwAwdDloMgA0QBRBkAVfMgTgT6xiIAAAAASUVORK5CYII=",
        name: "SeedSigner",
        slogan: "SeedSigner: Air-gapped DIY Bitcoin Signing Device",
        link: "https://lgt.st/seedsigner"
    },
    {
        category: "save",
        image: "foundation.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        platforms: [
            "web"
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/ABAJD6uMhqWHgBAJDwDtvbLpzMa/o5/pu68Aknl0jHd1eWZjinFuAAcFDv/y5P/y5QcJD2rwGGtYvUViAAAAAElFTkSuQmCC",
        name: "Foundation",
        slogan: "Reclaim your sovereignty with the new standard for Bitcoin self custody. Introducing Passport hardware wallet and Envoy mobile app.",
        link: "https://lgt.st/foundation"
    },
    {
        category: "save",
        image: "bitbox.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        platforms: [
            "web"
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAO0lEQVR4nAXBwQ0AQAQEQJ/NJV66UIDQggI07qcMJbgZYmYziwhmpvded8+MiJCq7u7duTsByMyqAvABfUwPfGOPixEAAAAASUVORK5CYII=",
        name: "BitBox",
        slogan: "Swiss-made hardware and software for easy Bitcoin and cryptocurrency storage.",
        link: "https://lgt.st/bitbox"
    },
    {
        category: "save",
        image: "jade.png",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        platforms: [
            "web"
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPUlEQVR4nGNgYmSvaWwJTU1lZeZgKKyt/fP736qLZ/1yMhmUvNz0ytOc57TLBPowcLFxS/i5SQV6cXPwAgDPpg/+ocjR2AAAAABJRU5ErkJggg==",
        name: "Blockstream Jade",
        slogan: "Blockstream Jade is an easy-to-use, purely open-source hardware wallet that offers advanced security for your Bitcoin.",
        link: "https://lgt.st/jade"
    }, 
];

;// CONCATENATED MODULE: ./lib/items/send.ts
var send = [];

;// CONCATENATED MODULE: ./lib/items/spend.ts

var spend = [
    {
        category: "spend",
        image: "btcmap.svg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/btcmap",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAIAAADETxJQAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMUlEQVR4nGNgyPJi6C9iKEhk8D28cu//3wzxHQwMiycv+Pufgd+AgSE2iKGxnaEgGQAntA55KRb8XgAAAABJRU5ErkJggg==",
        name: "BTC Map",
        slogan: "Easily find places to spend sats anywhere on the planet.",
        platforms: [
            "web",
            "mobile"
        ]
    },
    {
        category: "spend",
        image: "moon.jpg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/moon",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOElEQVR4nAXBoQ0AQAgDQCTiVRMUYdpqNDsxQidB/p0BqKrMBGAkJe0uSevuu5M0M+buEQHgvfcB5u4SplG5KjAAAAAASUVORK5CYII=",
        name: "Moon",
        slogan: "Purchase Moon Visa\xae Prepaid Cards with bitcoin. Pay at millions of online merchants with secure virtual cards.",
        platforms: [
            "web",
            "desktop"
        ]
    },
    {
        category: "spend",
        image: "bitrefill.png",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/bitrefill",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/AAAVDwAyMAAwLQAYEQAAFxGDpqTGx8hKCBgAAB0ZyLi6/87d/25NAAANCv9hWP9uVv9uRWGhEdk7IjWSAAAAAElFTkSuQmCC",
        name: "Bitrefill",
        slogan: "Purchase Gift Cards & Mobile Recharges in 170+ countries with BTC.",
        platforms: [
            "web",
            "mobile"
        ]
    },
    {
        category: "spend",
        image: "thebitcoincompany.jpg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/thebitcoincompany",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/AFwAAEoAAEkAAFEADQDCYFD/4N7/x8ytQFQAwGIx/9u5/8CnggAPAI4oAHgAAHQAAH4AAN8HEk3sGa4dAAAAAElFTkSuQmCC",
        name: "The Bitcoin Company",
        slogan: "The easiest way to spend bitcoin and earn rewards.",
        platforms: [
            "mobile"
        ]
    },
    {
        category: "spend",
        image: "lightningstore.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/lightningstore",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOklEQVR4nGPg4uQUk5SQVVJkY2FlYGBgOPX/07Lbp0AsNhZWI1dbaQU5Xh4eBk52dlMrB3ffUEYGBgDssgjKc7unUgAAAABJRU5ErkJggg==",
        name: "Lightning Store⚡",
        slogan: "Obscure Bitcoin pop cult/punk mashups 4 sale ⛓⚡️",
        platforms: [
            "web"
        ]
    },
    {
        category: "spend",
        image: "oshi.png",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/oshi",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALklEQVR4nGNgYGBgYWERFxdnZmZmYGBgePPmzb9//0AsTk7O3bt329jYgDjIAAAHRwkZ5bhLBwAAAABJRU5ErkJggg==",
        name: "Oshi",
        slogan: "Earn bitcoin by supporting your local economy.",
        platforms: [
            "mobile"
        ]
    },
    {
        category: "spend",
        image: "shamory.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/shamory",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALklEQVR4nGNgYGBgYWERFxdnZmZmYGBgePPmzb9//0AsTk7O3bt329jYgDjIAAAHRwkZ5bhLBwAAAABJRU5ErkJggg==",
        name: "SHAmory",
        slogan: "Buy SHAmory, the Bitcoin card game for kids 5+ and adults, as well as Goodnight Bitcoin and products ideal for Bitcoin babies, kids and parents	",
        platforms: [
            "desktop"
        ]
    },
    {
        category: "spend",
        image: "sparkwallet.png",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/spark",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALElEQVR4nGNgYGBgY+OQk1ZkgID/a57+v/8fxjl6+/+Co1COnIQYCzMTkAUAKGcLNDsIiM4AAAAASUVORK5CYII=",
        name: "Spark Wallet",
        slogan: "Earn Rewards on every transaction. Send and receive instantly. Get a visa debit card. Swap your bitcoin. Buy gift cards at 5% back. Earn free rewards when sharing Spark Wallet with your friends!",
        platforms: [
            "mobile"
        ]
    },
    {
        category: "spend",
        image: "ibexpay.jpeg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        link: "https://lgt.st/ibexpay",
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/AP///7i8zrO4yv///wDGydgAEUk+THnP0d4A1tjjAABAM0JytrrNAP///9/g6Ly+0Pn5+l/9IYM3mGUoAAAAAElFTkSuQmCC",
        name: "iBEXPay",
        slogan: "IBEX is a bitcoin infrastructure company specialized in the Lightning Network (LN) enterprise solutions.",
        platforms: [
            "web"
        ]
    }, 
];

;// CONCATENATED MODULE: ./lib/items/tip.ts

var tip = [
    {
        category: "tip",
        image: "lightsats.jpg",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        platforms: [
            "web"
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALUlEQVR4nGNgYGDg4uISERFhgIADBw58+/YVyvn9+/eJEyegHBEREVZWViALAB/1CxAyCekdAAAAAElFTkSuQmCC",
        name: "Lightsats",
        slogan: "Gift sats without losing them✌\uD83C\uDFFC",
        link: "/",
        lightsatsRecommended: true
    },
    {
        category: "tip",
        image: "tippinme.png",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        platforms: [
            "web"
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/ALaYj9u+tNzHxf/28QBgV2o8OVU/PVnKws4AHC5SDCJIPEVrxcXXAAAQQ0FchpOfvMXL4bEJGMeAmz8fAAAAAElFTkSuQmCC",
        name: "Tippin.me",
        slogan: "An easy way to receive small tips and micro-payments across the web, using Lightning Network and Bitcoin.",
        link: "https://lgt.st/tippin.me",
        lightsatsRecommended: false
    },
    {
        category: "tip",
        image: "lncash.png",
        languageCodes: [
            (0,iso6391/* getLanguageCode */.ht)("English")
        ],
        platforms: [
            "web"
        ],
        placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/AHtG13hB1gAAqgAAowCyhfC7ivOsgO0AALEA3sP///L/+9z/AACyAKS0/Vtt30Fh2QAApaNmGtJWYQUuAAAAAElFTkSuQmCC",
        name: "ln.cash",
        slogan: "Send and receive bitcoin on ln.cash",
        link: "https://lgt.st/lncash",
        lightsatsRecommended: false
    }, 
];

// EXTERNAL MODULE: ./lib/items/wallets.ts
var wallets = __webpack_require__(80498);
;// CONCATENATED MODULE: ./lib/items/catalog.ts









var catalog = {
    wallets: wallets/* wallets */.f,
    spend: spend,
    buy: buy,
    donate: donate,
    earn: earn,
    learn: learn,
    save: save,
    send: send,
    tip: tip
};


/***/ }),

/***/ 10380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dB": function() { return /* binding */ getOtherItems; },
/* harmony export */   "q5": function() { return /* binding */ getRecommendedItems; }
/* harmony export */ });
/* unused harmony exports getRecommendedWallets, sortItems */
/* harmony import */ var lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49711);
/* harmony import */ var lib_i18n_locales__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90390);
/* harmony import */ var lib_items_catalog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81100);



var categoryFilterFunctions = {
    wallets: getRecommendedWallets
};
var categoryScoringFuncs = {
    wallets: getWalletScore
};
function getRecommendedItems(category, locale, devicePlatform, options) {
    var ref;
    if (locale && !(0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .validateLanguageCode */ .Ve)(locale)) {
        throw new Error("Unsupported locale: " + locale);
    }
    var categoryItems = lib_items_catalog__WEBPACK_IMPORTED_MODULE_2__/* .catalog */ .F[category];
    var recommendedItems = categoryItems.filter(function(item) {
        return options.recommendedItemId && item.id === options.recommendedItemId || (!locale || item.languageCodes.indexOf(locale) > -1) && (!devicePlatform || osMatches(item, devicePlatform, false));
    });
    var ref1;
    recommendedItems = (ref1 = (ref = categoryFilterFunctions[category]) === null || ref === void 0 ? void 0 : ref.call(categoryFilterFunctions, recommendedItems, options)) !== null && ref1 !== void 0 ? ref1 : recommendedItems;
    sortItems(recommendedItems, categoryScoringFuncs[category], locale, devicePlatform, options);
    var limit = options.recommendedLimit;
    return recommendedItems.slice(0, limit);
}
function getOtherItems(category, options, recommendedItems, locale, devicePlatform) {
    var categoryItems = lib_items_catalog__WEBPACK_IMPORTED_MODULE_2__/* .catalog */ .F[category];
    var otherItems = categoryItems.filter(function(item) {
        return recommendedItems.indexOf(item) === -1;
    });
    if (options.filterOtherItems) {
        var ref;
        var ref1;
        otherItems = (ref1 = (ref = categoryFilterFunctions[category]) === null || ref === void 0 ? void 0 : ref.call(categoryFilterFunctions, otherItems, options)) !== null && ref1 !== void 0 ? ref1 : otherItems;
    }
    sortItems(otherItems, categoryScoringFuncs[category], locale, devicePlatform, options);
    return otherItems;
}
function getRecommendedWallets(items, options) {
    var _tippeeBalance;
    var recommendedWallets = items.filter(function(wallet) {
        return (!options.checkTippeeBalance || wallet.minBalance <= ((_tippeeBalance = options.tippeeBalance) !== null && _tippeeBalance !== void 0 ? _tippeeBalance : 0)) && (!options.lnurlAuthCapable || wallet.features.indexOf("lnurl-auth") > -1);
    });
    return recommendedWallets;
}
function sortItems(items, scoringFunc, locale, devicePlatform, options) {
    if (options.sortAlphabetically) {
        items.sort(function(a, b) {
            return a.name.localeCompare(b.name);
        });
    } else {
        items.sort(function(a, b) {
            return getItemScore(b, scoringFunc, locale, devicePlatform, options) - getItemScore(a, scoringFunc, locale, devicePlatform, options);
        });
    }
}
function getItemScore(item, scoringFunc, locale, devicePlatform, options) {
    var score = 0;
    if (item.lightsatsRecommended) {
        ++score;
    }
    if (locale && item.languageCodes.indexOf(locale) > -1) {
        score += 5;
    } else if (item.languageCodes.indexOf(lib_i18n_locales__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_LOCALE */ .Z) > -1) {
        score += 2;
    }
    if (devicePlatform && osMatches(item, devicePlatform, true)) {
        score += 5;
    }
    if (options.recommendedItemId && item.id === options.recommendedItemId) {
        score += 999999;
    }
    if (scoringFunc) {
        score += scoringFunc(item);
    }
    return score;
}
function osMatches(item, devicePlatform, strictDesktopCheck) {
    return item.platforms.indexOf("web") > -1 || !devicePlatform.isMobile && (!strictDesktopCheck || item.platforms.indexOf("desktop") > -1) || devicePlatform.isMobile && item.platforms.indexOf("mobile") > -1 || devicePlatform.isIos && item.platforms.indexOf("ios-only") > -1 || devicePlatform.isAndroid && item.platforms.indexOf("android-only") > -1;
}
function getWalletScore(item) {
    var wallet = item;
    var score = 0;
    if (wallet.features.indexOf("lnurl-auth") > -1) {
        ++score;
    }
    if (wallet.features.indexOf("non-custodial") > -1) {
        ++score;
    }
    if (wallet.features.indexOf("lightning address") > -1) {
        ++score;
    }
    if (wallet.platforms.indexOf("mobile") > -1) {
        ++score;
    }
    return score;
}


/***/ }),

/***/ 80498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ wallets; }
/* harmony export */ });
/* harmony import */ var lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49711);

var wos = {
    id: "wos",
    category: "wallets",
    features: [
        "lnurl-withdraw",
        "lightning address",
        "lnurl-auth"
    ],
    minBalance: 0,
    link: "https://lgt.st/walletofsatoshi",
    image: "wos.png",
    lightsatsRecommended: true,
    placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAPUlEQVR4nGNQVlH6/9kzN0GFgUGeIdRX5f8P7+5KVS1NJQYFJaX1M1QvbNIXk1Jk4BdRDPVVkVdQ4hdRBACfdA3crpCdPAAAAABJRU5ErkJggg==",
    name: "Wallet Of Satoshi",
    slogan: "The world's simplest Bitcoin Lightning Wallet\nRecommended by SVRN Energy for first time Bitcoiners.",
    instructions: "1. Download the Wallet of Satoshi app by clicking the Install ↗️ button below.\n2. Sign up for a Wallet of Satoshi account to enable login with lightning. You will get an email with magic words that you need to use to login to Wallet of Satoshi.\n3. Return to SVRN Energy to claim your tip.",
    languageCodes: [
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Arabic"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Bulgarian"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Czech"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Deutsch"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("English"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Spanish"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Persian"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Finnish"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("French"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Croatian"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Italian"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Chinese"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Malay"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Norwegian"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Polish"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Portuguese"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Russian"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Swedish"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Thai"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Turkish"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Urdu"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Vietnamese"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Japanese"), 
    ],
    platforms: [
        "mobile"
    ]
};
//
var muun = {
    id: "muun",
    category: "wallets",
    features: [
        "lnurl-withdraw",
        "non-custodial"
    ],
    minBalance: 0,
    link: "https://lgt.st/muun",
    image: "muun.png",
    placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/AABDmQBGnQA7kQAdcwAAY7bL//+58f8ARZoAAFirJ4rYIofUAE2gAAAgdgAdcgAZbQARZehsEZ3ZbJxEAAAAAElFTkSuQmCC",
    name: "Muun Wallet",
    slogan: "Simple and powerful. Just like bitcoin.",
    instructions: "No fee to accumulate rewards, but withdraw fees can be high.\n\n1. Download the Muun app by clicking the Install ↗️ button below.",
    languageCodes: [
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("English"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Spanish")
    ],
    platforms: [
        "mobile"
    ]
};
var speed = {
    id: "speed",
    category: "wallets",
    features: [
        "lnurl-withdraw",
        "lightning address",
        "lnurl-auth"
    ],
    minBalance: 0,
    link: "https://www.speed.app",
    image: "speed.jpeg",
    lightsatsRecommended: true,
    placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/AABDmQBGnQA7kQAdcwAAY7bL//+58f8ARZoAAFirJ4rYIofUAE2gAAAgdgAdcgAZbQARZehsEZ3ZbJxEAAAAAElFTkSuQmCC",
    name: "Speed Wallet",
    instructions: "1. Download the Speed app by clicking the Install ↗️ button below.\n2. Sign up for a Speed account. You will get an email with a magic link to login to Speed.\n3. Return to SVRN Energy to claim your tip.",
    slogan: "Payments at the speed of light",
    languageCodes: [
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("English"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Spanish")
    ],
    platforms: [
        "mobile"
    ]
};
var breez = {
    id: "breez",
    features: [
        "lnurl-auth",
        "lnurl-withdraw",
        "non-custodial"
    ],
    category: "wallets",
    minBalance: 3000,
    link: "https://lgt.st/breez",
    image: "breez.png",
    placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAABnWAAAZ1gEY0crtAAAAP0lEQVR4nAE0AMv/AP////v7/ODn7P///wDz9vcAOFsAHEH19vgA+/v8AERmABY85uvvAP////n6+9vi6P///7k8JI6gkKogAAAAAElFTkSuQmCC",
    name: "Breez Wallet",
    slogan: "Lightning fast bitcoin payments.",
    instructions: "1. Download the Breeze app by clicking the Install ↗️ button below.",
    languageCodes: [
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("English"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Finnish"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("French"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Italian"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Spanish"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Portuguese"), 
    ],
    platforms: [
        "mobile"
    ]
};
var alby = {
    id: "alby",
    features: [
        "lnurl-auth",
        "lnurl-withdraw",
        "non-custodial",
        "lightning address", 
    ],
    lightsatsRecommended: true,
    category: "wallets",
    minBalance: 0,
    link: "https://lgt.st/alby",
    image: "alby.png",
    placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/APX09re0qbOuo/j4+gD4+PcfFAAXBQDz8/MA9/j8QDscQz0e6+zuAP///+3t7Ovq6v///1l5IlUqU4AsAAAAAElFTkSuQmCC",
    name: "Alby Wallet",
    slogan: "Lightning buzz for your Browser!",
    languageCodes: [
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("English"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Spanish"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Portuguese"), 
    ],
    platforms: [
        "desktop"
    ]
};
var phoenix = {
    id: "phoenix",
    features: [
        "lnurl-auth",
        "lnurl-withdraw",
        "non-custodial"
    ],
    category: "wallets",
    minBalance: 10000,
    link: "https://lgt.st/phoenix",
    image: "phoenix.jpeg",
    placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAE0AMv/AP///8jPx87TzP///wDX3NZKXUYAGwCAj34ArberECsMJj4hxc3EAPT19NTa0/z9/P///0JGIGVwaLfEAAAAAElFTkSuQmCC",
    name: "Phoenix",
    slogan: "The Bitcoin wallet from the future",
    languageCodes: [
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("English")
    ],
    platforms: [
        "mobile"
    ]
};
var lntips = {
    id: "lntips",
    features: [],
    category: "wallets",
    minBalance: 0,
    link: "https://lgt.st/lntips",
    image: "lntips.jpeg",
    placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPUlEQVR4nGNgZfER5AhmYPBgYPBkMGNI2l1248XV/0riCQxOjDmTU/f8//h/Ss1xBkYWHwYGFwYGNxY2HwCGSQ+j4puuEwAAAABJRU5ErkJggg==",
    name: "lntips (Telegram)",
    slogan: "Bitcoin Lightning wallet on Telegram.",
    languageCodes: [
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("English")
    ],
    platforms: [
        "mobile"
    ]
};
var obw = {
    id: "obw",
    features: [
        "lnurl-auth",
        "lnurl-withdraw",
        "non-custodial"
    ],
    category: "wallets",
    minBalance: 0,
    link: "https://lgt.st/obw",
    image: "obw.webp",
    placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAALElEQVR4nGP4/+g/HDGsav3PweDMzmBfFHaUoSD0sACnr5Rg2LVV/xmQlQEAPnQgO33asswAAAAASUVORK5CYII=",
    name: "OBW",
    slogan: "It is a simple, fast, intuitive wallet app, using advanced technology, open source, free, non-custodial, non-KYC.",
    languageCodes: [
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("English")
    ],
    platforms: [
        "android-only"
    ]
};
var bbw = {
    id: "bbw",
    features: [
        "lnurl-withdraw",
        "lightning address"
    ],
    category: "wallets",
    minBalance: 0,
    link: "https://lgt.st/bbw",
    image: "bbw.png",
    placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANUlEQVR4nGP4////+eV9T87u+///P8P///+btRj2tGRBOH/FGVQYRGIhnH/1sw/N3nkFyAEAqOAjYOEgd8oAAAAASUVORK5CYII=",
    name: "Bitcoin Beach Wallet",
    slogan: "The Bitcoin Beach Wallet, the most secure and accessible Lightning-enabled Bitcoin wallet that makes receiving, saving and spending Bitcoin easy.",
    languageCodes: [
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("English"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Spanish"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Portuguese"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Czech"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("German"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("French"), 
    ],
    platforms: [
        "mobile"
    ]
};
var zeus = {
    id: "zeus",
    features: [
        "lnurl-auth",
        "lnurl-withdraw",
        "non-custodial"
    ],
    category: "wallets",
    minBalance: 0,
    link: "https://lgt.st/zeus",
    image: "zeus.webp",
    placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAP0lEQVR4nAE0AMv/AP/IJ//mMv/sRv/QQQD/4lKDdiV1dm3/5VsA//iZ3de+bWUq/9orAP/KLf/XPgABCPi0NiumHSY+n4GVAAAAAElFTkSuQmCC",
    name: "Zeus",
    slogan: "Zeus is an open-source, non-custodial Bitcoin wallet that gives you full control over how you make payments.  This wallet requires a Lightning node to use.",
    languageCodes: [
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("English"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Spanish"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Portuguese"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("Czech"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("German"),
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("French"), 
    ],
    platforms: [
        "mobile"
    ]
};
var zebedee = {
    id: "zebedee",
    features: [
        "lightning address"
    ],
    category: "wallets",
    minBalance: 0,
    link: "https://lgt.st/zebedee",
    image: "zebedee.jpeg",
    placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVR4nGMQFtfg4JTi4JQSk9RmqKyb9OXn/w9f/heVdTGUV/ffe/zjwbPfWblNDMLiGqwcUsxsEkBlAPPnExX6CVBpAAAAAElFTkSuQmCC",
    name: "ZEBEDEE",
    slogan: "We make the points you earn in games matter. By harnessing the power of Bitcoin, we attach real-world value to points, scores and economies in virtual worlds",
    languageCodes: [
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("English")
    ],
    platforms: [
        "mobile"
    ]
};
var blixt = {
    id: "blixt",
    features: [
        "lnurl-auth",
        "lnurl-withdraw",
        "non-custodial"
    ],
    category: "wallets",
    minBalance: 0,
    link: "https://lgt.st/blixt",
    image: "blixt.jpeg",
    placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOElEQVR4nGPYN4Xh6GyGfVNAiKEzieH/z8q7m/g6kxgYYs0YtvQw/H+cGWvGwGDNwmDLA0LWLAwAHQ0Q/Bk/+cgAAAAASUVORK5CYII=",
    name: "Blixt",
    instructions: "1. Download the Blixt app by clicking the Install ↗️ button below.",
    slogan: "Blixt Wallet is a non-custodial open-source Bitcoin Lightning Wallet for Android with focus on usability and user experience, powered by lnd and Neutrino SPV.",
    languageCodes: [
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("English")
    ],
    platforms: [
        "android-only"
    ]
};
var pouch = {
    id: "pouch",
    features: [
        "lnurl-withdraw"
    ],
    category: "wallets",
    minBalance: 0,
    link: "https://lgt.st/pouch",
    image: "pouch.jpeg",
    placeholderDataUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANUlEQVR4nB3JsQmAMBQFwNvRpRxB+KRJsMgoqdzAVZ6S7uAwmLQNlZXnDDfae6WO0O3t1I8PuhYRDqtUbxoAAAAASUVORK5CYII=",
    name: "Pouch",
    slogan: "Made with ❤️ in the Philippines. Pouch supports philippine peso payments over bitcoin's Lightning Network ⚡",
    languageCodes: [
        (0,lib_i18n_iso6391__WEBPACK_IMPORTED_MODULE_0__/* .getLanguageCode */ .ht)("English")
    ],
    platforms: [
        "mobile"
    ]
};
var wallets = [
    phoenix,
    muun,
    breez,
    blixt,
    speed
];


/***/ })

}]);